import React, { useMemo } from 'react';
import { Palette } from 'lucide-react';
import { useSpineRuntimeStore } from '../../../store/spineStore';

interface SpineSkinPickerProps {
  value: string;
  spineAssetId: string | null;
  onChange: (skinName: string) => void;
  disabled?: boolean;
}

export const SpineSkinPicker: React.FC<SpineSkinPickerProps> = ({
  value,
  spineAssetId,
  onChange,
  disabled = false,
}) => {
  const loadedAssets = useSpineRuntimeStore((s) => s.loadedAssets);

  const skins = useMemo(() => {
    if (!spineAssetId || !loadedAssets[spineAssetId]) {
      return ['default'];
    }
    return loadedAssets[spineAssetId].skins.map((s) => s.name);
  }, [spineAssetId, loadedAssets]);

  return (
    <div className="flex items-center gap-2">
      <Palette className="w-4 h-4 text-purple-400 flex-shrink-0" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || !spineAssetId}
        className="flex-1 bg-zinc-800 border border-zinc-700 rounded px-2 py-1 text-sm text-zinc-200 disabled:opacity-50"
      >
        {skins.map((skin) => (
          <option key={skin} value={skin}>
            {skin}
          </option>
        ))}
      </select>
    </div>
  );
};
